function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useMemo, useState } from 'react';
import Dropdown from '@rd-web-markets/shared/dist/util/Dropdown';
import { TextFormFieldRow } from '@rd-web-markets/shared/dist/util/form';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import { useTranslation } from 'react-i18next';
import IsNotSaved from '../IsNotSaved';
import powerOfAttorneyService from '../../../services/company/power_of_attorney.service';
const BOOLEAN_OPTIONS = [{
  key: 'attorney_should_send_yes',
  value: 'true',
  text: 'yes'
}, {
  key: 'attorney_should_send_no',
  value: 'false',
  text: 'no'
}];
const TEXT_FIELDS = ['salutation', 'name_line_1', 'name_line_2', 'street', 'house_number', 'postal_code_domestic', 'city', 'postal_code_foreign', 'state'];
const PowerOfAttorney = _ref => {
  let {
    elster
  } = _ref;
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isNotSaved, setIsNotSaved] = useState(false);
  const isVersion8 = (elster === null || elster === void 0 ? void 0 : elster.version_number) === 'version_8';
  const {
    powerOfAttorney,
    setPowerOfAttorney,
    updatePowerOfAttorney
  } = powerOfAttorneyService.useCrud(elster === null || elster === void 0 ? void 0 : elster.id, setLoading);
  const headingKey = useMemo(() => isVersion8 ? 'power_of_attorney_1_1_version_8' : 'power_of_attorney_1_1_version_7', [isVersion8]);
  const saveData = useCallback(async body => {
    await updatePowerOfAttorney({
      power_of_attorney: body
    });
    setIsNotSaved(false);
  }, [updatePowerOfAttorney]);
  const updateLocal = useCallback((key, value) => {
    setPowerOfAttorney(prev => _objectSpread(_objectSpread({}, prev || {}), {}, {
      [key]: value
    }));
    setIsNotSaved(true);
  }, [setPowerOfAttorney]);
  if (loading && powerOfAttorney == null) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "mb-3"
  }, t(headingKey)), /*#__PURE__*/React.createElement(Dropdown, {
    name: "research_allowance_should_be_send_different_recipient",
    fieldName: "research_allowance_should_be_send_different_recipient",
    label: "research_allowance_should_be_send_different_recipient",
    value: powerOfAttorney === null || powerOfAttorney === void 0 ? void 0 : powerOfAttorney.research_allowance_should_be_send_different_recipient,
    onChange: val => updateLocal('research_allowance_should_be_send_different_recipient', val),
    options: BOOLEAN_OPTIONS,
    dataTestId: "power_of_attorney_research_allowance_should_be_send_different_recipient",
    labelColSpan: 6,
    showNullOption: true
  }), TEXT_FIELDS.map(fieldName => /*#__PURE__*/React.createElement(TextFormFieldRow, {
    key: fieldName,
    fieldName: fieldName,
    label: fieldName,
    value: (powerOfAttorney === null || powerOfAttorney === void 0 ? void 0 : powerOfAttorney[fieldName]) || '',
    onChange: e => updateLocal(fieldName, e.target.value),
    labelColSpan: 6,
    dataTestId: "power_of_attorney_".concat(fieldName)
  })), /*#__PURE__*/React.createElement(IsNotSaved, {
    isNotSaved: isNotSaved,
    save: saveData,
    paramsForUpdate: [powerOfAttorney],
    loading: loading
  }));
};
export default PowerOfAttorney;